<template>
  <v-dialog v-model="visible" max-width="460" persistent>
    <v-card>
      <v-card-title class="text-subtitle-1 pb-1">
        <v-icon class="mr-2" color="red darken-1">mdi-delete-alert-outline</v-icon>
        Elimina stagione
      </v-card-title>
      <v-divider/>

      <v-card-text class="pt-4">
        <!-- Caricamento dry-run -->
        <div v-if="loading_dry_run" class="text-center py-6">
          <v-progress-circular indeterminate color="red darken-1" size="36"/>
          <div class="caption grey--text mt-3">Verifica dei dati in corso…</div>
        </div>

        <!-- Errore dry-run -->
        <v-alert v-else-if="errore" type="error" outlined dense>{{ errore }}</v-alert>

        <!-- Riepilogo dati che verranno eliminati -->
        <template v-else-if="counts">
          <div class="text-body-2 mb-3">
            Stai per eliminare la stagione
            <strong>{{ nome_stagione }}</strong>.
            Questa operazione è <strong>irreversibile</strong> e rimuoverà:
          </div>

          <v-simple-table dense class="mb-3">
            <tbody>
              <tr v-for="voce in voci_counts" :key="voce.key">
                <td class="text-body-2 grey--text text--darken-1">{{ voce.label }}</td>
                <td class="text-body-2 text-right font-weight-medium"
                    :class="voce.valore > 0 ? 'red--text text--darken-1' : 'grey--text'">
                  {{ voce.valore }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-alert v-if="totale === 0" type="info" outlined dense class="mb-0">
            La stagione è vuota e può essere eliminata senza perdita di dati.
          </v-alert>
          <v-alert v-else type="warning" outlined dense class="mb-0">
            Verranno eliminati {{ totale }} record in totale.
          </v-alert>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-btn text :disabled="loading_delete" @click="close">Annulla</v-btn>
        <v-spacer/>
        <v-btn
          color="red darken-1"
          dark
          :loading="loading_delete"
          :disabled="loading_dry_run || !!errore"
          @click="conferma"
        >
          <v-icon small class="mr-1">mdi-delete</v-icon>
          Elimina definitivamente
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const LABELS = {
  prodotti_pianificazione:  'Prodotti pianificati',
  posizioni_serre_snapshot: 'Posizionamenti serre',
  prodotti_arrivo:          'Prodotti arrivo',
  file_stagione:            'File / Bancali configurate',
  layout_mappa:             'Mappe stagionali (fork)',
};

export default {
  name: "EliminaStagioneDialog",
  data() {
    return {
      visible:        false,
      stagione:       null,
      counts:         null,
      loading_dry_run: false,
      loading_delete:  false,
      errore:          '',
    };
  },
  computed: {
    nome_stagione() {
      if (!this.stagione) return '';
      const tipo = this.stagione.tipo_stagione?.nome || '';
      return `${tipo} ${this.stagione.anno}`.trim();
    },
    voci_counts() {
      if (!this.counts) return [];
      return Object.entries(this.counts).map(([key, valore]) => ({
        key,
        label: LABELS[key] || key,
        valore,
      }));
    },
    totale() {
      if (!this.counts) return 0;
      return Object.values(this.counts).reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    async openDialog(stagione) {
      this.stagione       = stagione;
      this.counts         = null;
      this.errore         = '';
      this.loading_delete = false;
      this.visible        = true;
      this.loading_dry_run = true;
      try {
        const response = await this.$store.dispatch('deleteStagioneColtivazione', {
          id: stagione.id,
          dry_run: true,
        });
        this.counts = response.da_eliminare;
      } catch (e) {
        this.errore = e?.response?.data?.message || 'Errore nel recupero dei dati.';
      } finally {
        this.loading_dry_run = false;
      }
    },
    async conferma() {
      if (!this.stagione) return;
      this.loading_delete = true;
      try {
        await this.$store.dispatch('deleteStagioneColtivazione', {
          id: this.stagione.id,
          dry_run: false,
        });
        this.$emit('stagione-eliminata', this.stagione.id);
        this.close();
      } catch (e) {
        this.errore = e?.response?.data?.message || 'Errore durante l\'eliminazione.';
      } finally {
        this.loading_delete = false;
      }
    },
    close() {
      this.visible  = false;
      this.stagione = null;
      this.counts   = null;
      this.errore   = '';
    },
  },
};
</script>
